




























import { QBtn, QCard, QDialog, QField, QInput, QSelect } from 'quasar'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    QDialog,
    QBtn,
    QField,
    QInput,
    QSelect,
    QCard,
  },
})
export default class Modal extends Vue {
  @Prop({ type: String, default: '' }) public title!: string
  @Prop({ type: Boolean, default: false }) public hideButtons!: boolean

  public hide(): void {
    this.$emit('hide')
  }

  public submit(): void {
    this.$emit('submit')
  }
}
